import React, { FC } from 'react';

import { Table } from '@column/column-ui-kit';

import { useCounterpartyDropdown, useDebounce } from '~/hooks';

interface CounterpartyCellProps {
  isEditable?: boolean;
  value?: string;
  onChange?: ({ description, id }: { description: string; id: string }) => void;
}

export const CounterpartyCell: FC<CounterpartyCellProps> = ({ isEditable, value, onChange }) => {
  const { options, hiddenOptions, searchCounterparties, isLoading } = useCounterpartyDropdown(value);

  const handleSearchCounterparties = useDebounce(
    (searchVal?: string) => {
      searchCounterparties(searchVal);
    },
    500,
    [searchCounterparties]
  );

  return (
    <Table.OptionCell
      isEditable={isEditable}
      value={value}
      options={options}
      hiddenOptions={hiddenOptions}
      fullWidth
      search
      searchLabel="Search..."
      onSearchChange={handleSearchCounterparties}
      isLoading={isLoading}
      onChange={(newValue: string) => {
        onChange?.({
          description: options.find((option) => option.value === newValue)?.label ?? '',
          id: newValue,
        });
      }}
    />
  );
};
